export default __webpack_public_path__ + "static/media/logo_id_house_inova.0a9bedd4.svg";